/**
 * 骑士管理
 */
import React from 'react';
import PropTypes from 'prop-types';
import KeepAlive from '@/routes/KeepAlive';
import styles from './index.module.scss';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import model from '@/reducers/user/rider/model';
import { autoPageNum, autopageSize } from '@/assets/config';
import { connect } from 'react-redux';
import StateUpdateModal from './modal/StateUpdateModal';
import RelationshipModel from './modal/RelationshipModel';
import http from '@/assets/api/http';
import { message } from 'antd';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

class Main extends React.Component {

    state = {
        openModalType: '',
        openModalParam: {},
        tel: '', // 手机号码
        realName: '', // 骑士姓名
        level: {}, // 骑士等级
        riderState: {}, // 骑士状态
        receiveOrderCountCompare: {}, // 接单比较
        receiveOrderCount: '', // 接单数量
        sendOrderCountCompare: {}, // 派单比较
        sendOrderCount: '', // 派单数量
        gmtCreateStart: undefined, // 开通时间-开始
        gmtCreateEnd: undefined, // 开通时间-结束
        cardNum: '', // 身份证号码
        openRelationshipModalType: '',
        openRelationshipModalParam: {},
        relationshipValue:'',
        pageNum:1,
        pageSize:30,
        zoneFlagEnum:[{code:1,value:'是'},{code:0,value:'否'}],
        zoneFlag:{}
    }

    componentDidMount() {
        this.props.getRiderLevelList();
        this.props.getRiderStateList();
        this.props.getScoreCompare();
        // this.setState({ receiveOrderCountCompare: { code: 'EGT', value: '大于等于' }, sendOrderCountCompare: { code: 'EGT', value: '大于等于' } }); // 初始化默认值
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
    }

    _searchHandle = (useCache) => {
        if(useCache !== 'useCache'){
            this.setState({
                pageNum:1,
                pageSize:30
            })
        }
        const { pageNum, pageSize, tel, cardNum, realName, level, riderState, sendOrderCountCompare, sendOrderCount, receiveOrderCountCompare, receiveOrderCount, gmtCreateStart, gmtCreateEnd,zoneFlag } = this.state;
        
        let query = {};
        query = {
            tel,
            realName,
            cardNum,
            levelId: level.id,
            status: riderState.code,
            sendOrderCount: sendOrderCount ? { compare: sendOrderCountCompare.code, num: sendOrderCount } : undefined,
            receiveOrderCount: receiveOrderCount ? { compare: receiveOrderCountCompare.code, num: receiveOrderCount } : undefined,
            gmtCreateStart,
            gmtCreateEnd,
            zoneFlag:zoneFlag.code,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum,
            pageSize: useCache == 'useCache' ? pageSize : autopageSize,
        };
        this.props.getRiderList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    _resetHandle = () => {
        this.setState({
            tel: '', // 手机号码
            realName: '', // 骑士姓名
            cardNum: '', // 身份证号
            level: {}, // 骑士等级
            riderState: {}, // 骑士状态
            receiveOrderCountCompare: {}, // 接单比较
            receiveOrderCount: '', // 接单数量
            sendOrderCountCompare: {}, // 派单比较
            sendOrderCount: '', // 派单数量
            gmtCreateStart: undefined, // 注册时间-开始
            gmtCreateEnd: undefined, // 注册时间-结束
            zoneFlag:{}
        }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    // 表格操作
    _tableAction = (type, record,value) => {
        const { history } = this.props;
        const { id, mobilePhone, smallTransportId } = record;
        let disable;
        switch (type) {
            case 'detail': // 详情
                if(record.smallTransportId){
                    history.push({ pathname: '/home/user/rider/detail/' + id + '/' + smallTransportId});
                }else{
                    history.push({ pathname: '/home/user/rider/detail/' + id});
                }
                break;
            case 'violation':  // 骑士罚单
                history.push({
                    pathname: '/home/aftersale/deliveryticket/' + mobilePhone,
                });
                break;
            case 'evaluate': // 骑士评价
                history.push({
                    pathname: '/home/aftersale/deliveryeval/' + mobilePhone,
                });
                break;
            case 'available': // 启用禁用
                disable = record.state == 'DISABLE' || record.state == 'BLACK' ? true : false;
                if (disable) {
                    // 启用
                    http('/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.riderStateUpdate', { riderId: record.id, riderState: 'ENABLE' }, 'POST').then(() => {
                        message.success('启用成功');
                        this.setState({ openModalType: '', openModalParam: {} }, () => {
                            this._searchHandle('useCache');
                        });
                    }).catch((e) => {
                        message.error(e.message);
                    });
                } else {
                    // 禁用
                    this.setState({ openModalType: 'disable', openModalParam: { riderId: record.id } });
                }
                break;
            case 'RelationshipAvailable': // 骑士修改运力公司
                this.setState({relationshipValue:value, openRelationshipModalType: 'disable', openRelationshipModalParam: record })
                break;
        }
    }

    //渲染骑士修改运力公司弹窗
    _renderRelationshipModal = () => {
        const { openRelationshipModalType, openRelationshipModalParam,relationshipValue } = this.state;
        switch (openRelationshipModalType) {
            case 'disable':
                return <RelationshipModel visible={true} data={openRelationshipModalParam} valueType={relationshipValue} closeModal={(update) => this._closeRelationshipModal(update)} />;
            default:
                return null;
        }
    }

    // 关闭修改运力公司弹窗
    _closeRelationshipModal = (update) => {
        this.setState({ openRelationshipModalType: '', openRelationshipModalParam: {} }, () => {
            if (update) {
                this._searchHandle('useCache');
            }
        });
    }

    // 渲染弹窗
    _renderModal = () => {
        const { openModalType, openModalParam } = this.state;
        switch (openModalType) {
            case 'disable':
                return <StateUpdateModal visible={true} data={openModalParam} closeModal={this._closeModal} />;
            default:
                return null;
        }
    }

    // 关闭弹窗
    _closeModal = (update) => {
        this.setState({ openModalType: '', openModalParam: {} }, () => {
            if (update) {
                this._searchHandle('useCache');
            }
        });
    }

    render() {
        const { tel, realName, level, riderState, receiveOrderCountCompare, receiveOrderCount, sendOrderCountCompare, sendOrderCount, gmtCreateStart, gmtCreateEnd, cardNum,zoneFlagEnum,zoneFlag } = this.state;
        const { riderList, riderLevelList, riderStateList, scoreCompare } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 调用查询接口初始化数据
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='手机号码'
                                placeholder='请输入手机号码'
                                value={tel}
                                bindThis={this}
                                bindName='tel'
                                maxLength={11}
                                mode='number'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='姓名'
                                placeholder='请输入姓名'
                                value={realName}
                                bindThis={this}
                                bindName='realName'
                                mode='chiLetNum'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='骑士等级'
                                placeholder='请选择骑士等级'
                                renderData={riderLevelList}
                                dataIndex='name'
                                keyIndex='id'
                                value={level.name}
                                bindThis={this}
                                bindName='level'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='骑士状态'
                                placeholder='请选择骑士状态'
                                renderData={riderStateList}
                                dataIndex='value'
                                keyIndex='code'
                                value={riderState.value}
                                bindThis={this}
                                bindName='riderState'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                style={{ marginRight: 0 }}
                                selectStyle={{ width: '100px' }}
                                label='派单数量'
                                placeholder='请选择'
                                renderData={scoreCompare}
                                dataIndex='value'
                                keyIndex='code'
                                value={sendOrderCountCompare.value}
                                bindThis={this}
                                bindName='sendOrderCountCompare'
                                showSearch={true}
                            />
                            <XInputNum
                                label=''
                                placeholder='请输入派单数量'
                                value={sendOrderCount}
                                bindThis={this}
                                bindName='sendOrderCount'
                                precision={0}
                                min={0}
                                max={999999}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                style={{ marginRight: 0 }}
                                selectStyle={{ width: '100px' }}
                                label='接单数量'
                                placeholder='请选择'
                                renderData={scoreCompare}
                                dataIndex='value'
                                keyIndex='code'
                                value={receiveOrderCountCompare.value}
                                bindThis={this}
                                bindName='receiveOrderCountCompare'
                                showSearch={true}
                            />
                            <XInputNum
                                label=''
                                placeholder='请输入接单数量'
                                value={receiveOrderCount}
                                bindThis={this}
                                bindName='receiveOrderCount'
                                precision={0}
                                min={0}
                                max={999999}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='注册时间'
                                value={gmtCreateStart}
                                bindThis={this}
                                bindName='gmtCreateStart'
                                isFormat
                            />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                label=''
                                value={gmtCreateEnd}
                                bindThis={this}
                                bindName='gmtCreateEnd'
                                isFormat
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='身份证号码'
                                placeholder='请输入身份证号码'
                                value={cardNum}
                                bindThis={this}
                                bindName='cardNum'
                                maxLength={18}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='关联区域'
                                placeholder='请选择'
                                renderData={zoneFlagEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={zoneFlag.value}
                                bindThis={this}
                                bindName='zoneFlag'
                                showSearch={true}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <TableContent renderData={riderList} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                    {this._renderModal()}
                    {this._renderRelationshipModal()}
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    getRiderList: PropTypes.func,
    riderList: PropTypes.object,
    getRiderLevelList: PropTypes.func,
    riderLevelList: PropTypes.array,
    getRiderStateList: PropTypes.func,
    riderStateList: PropTypes.array,
    getScoreCompare: PropTypes.func,
    scoreCompare: PropTypes.array,
    setBreadcrumbPaths: PropTypes.func,
};

const mapStateToProps = (state) => ({
    riderList: state.rider.getRiderList,
    riderLevelList: state.rider.getRiderLevelList,
    riderStateList: state.rider.getRiderStateList,
    scoreCompare: state.rider.getScoreCompare,
});
export default connect(mapStateToProps, { ...model.actions, setBreadcrumbPaths })(Main);